/**
 * Barra de herramientas flotante para bloques (mover, duplicar, eliminar).
 */

import { ChevronUp, ChevronDown, Trash2, Copy } from 'lucide-react';

interface BlockToolbarProps {
    onMoveUp?: () => void;
    onMoveDown?: () => void;
    onRemove?: () => void;
    onDuplicate?: () => void;
    isFirst?: boolean;
    isLast?: boolean;
}

export function BlockToolbar({
    onMoveUp,
    onMoveDown,
    onRemove,
    onDuplicate,
    isFirst,
    isLast,
}: BlockToolbarProps) {
    return (
        <div className="absolute -top-3 right-2 z-10 flex items-center gap-0.5 bg-background border border-border rounded-lg shadow-md px-1 py-0.5 opacity-0 group-hover/block:opacity-100 transition-opacity">
            {onMoveUp && !isFirst && (
                <button
                    type="button"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onMoveUp();
                    }}
                    className="p-1 rounded hover:bg-muted transition-colors"
                    title="Subir"
                >
                    <ChevronUp className="w-3.5 h-3.5 text-muted-foreground" />
                </button>
            )}
            {onMoveDown && !isLast && (
                <button
                    type="button"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onMoveDown();
                    }}
                    className="p-1 rounded hover:bg-muted transition-colors"
                    title="Bajar"
                >
                    <ChevronDown className="w-3.5 h-3.5 text-muted-foreground" />
                </button>
            )}
            {onDuplicate && (
                <button
                    type="button"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onDuplicate();
                    }}
                    className="p-1 rounded hover:bg-muted transition-colors"
                    title="Duplicar"
                >
                    <Copy className="w-3.5 h-3.5 text-muted-foreground" />
                </button>
            )}
            {onRemove && (
                <button
                    type="button"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onRemove();
                    }}
                    className="p-1 rounded hover:bg-red-100 transition-colors"
                    title="Eliminar"
                >
                    <Trash2 className="w-3.5 h-3.5 text-red-500" />
                </button>
            )}
        </div>
    );
}
